import { createElement, useEffect, useLayoutEffect, useRef } from "react";

export const AVATARS = [
  ["entrenador", "Entrenador", "#ff3b30"], ["entrenadora", "Entrenadora", "#ff4fa3"],
  ["zorro", "Zorro", "#ff8a3d"], ["dragon-sombra", "Dragón sombra", "#ff5a36"],
  ["encapuchado", "Encapuchado", "#a78bfa"], ["gamer-azul", "Gamer azul", "#3b82f6"],
  ["gato-espiritu", "Gato espíritu", "#7dd3fc"], ["buho", "Búho", "#d6a35c"],
  ["lobo", "Lobo", "#f97316"], ["dragon-hoja", "Dragón hoja", "#22c55e"],
  ["dragon-morado", "Dragón morado", "#a855f7"], ["golem-cristal", "Gólem cristal", "#f59e0b"],
  ["dragon-agua", "Dragón agua", "#38bdf8"], ["panda", "Panda", "#f472b6"],
  ["grifo", "Grifo", "#facc15"], ["dragon-hielo", "Dragón de hielo", "#93c5fd"],
].map(([id, label, aura]) => ({ id, label, aura, dir: `/avatars/${id}/` }));

// Ids numéricos antiguos ("01"–"16") → slug.
export const toAvatarSlug = (id) => (/^\d{1,2}$/.test(String(id || "")) ? AVATARS[Number(id) - 1]?.id || null : id || null);
export const avatarById = (id) => AVATARS.find((a) => a.id === toAvatarSlug(id)) || null;

const FX_FACE = { notify: "notificacion", bid: "puja" };
const decoded = new Map();
// Decodifica la cara antes de disparar el fx para que el cambio instantáneo no parpadee.
const ensureFace = (url) => {
  if (!decoded.has(url)) {
    const im = new Image();
    im.decoding = "async";
    im.src = url;
    decoded.set(url, (im.decode ? im.decode() : Promise.resolve()).catch(() => {}).then(() => im));
  }
  return decoded.get(url);
};

let fxSeq = 0;
export const nextFx = (type) => `${type}-${++fxSeq}`;

// Bus global: el encabezado escucha estos eventos (notify / thinking / abrir selector).
export const avatarBus = {
  notify: () => window.dispatchEvent(new CustomEvent("hit-avatar:notify")),
  thinking: (on) => window.dispatchEvent(new CustomEvent("hit-avatar:thinking", { detail: !!on })),
  openPicker: (mode = "cambiar") => window.dispatchEvent(new CustomEvent("hit-avatar:open-picker", { detail: mode })),
};

export const HitAvatar = ({ avatarId, name, size = 36, state = "active", fx, amount, rank, lite, toward, still, onFxEnd, className, testid }) => {
  const ref = useRef(null);
  const av = avatarById(avatarId);
  useEffect(() => {
    const el = ref.current;
    if (!el || !onFxEnd) { return undefined; }
    el.addEventListener("fxend", onFxEnd);
    return () => el.removeEventListener("fxend", onFxEnd);
  }, [onFxEnd]);
  const attrs = {
    size: String(size), state, initial: (name || "?").trim()[0] || "?", alt: name ? `Avatar de ${name}` : "Avatar",
    src: av ? `${av.dir}activo.webp` : null, aura: av ? av.aura : null, amount: amount || null,
    rank: rank || null, lite: lite ? "" : null, still: still ? "" : null, toward: toward || null,
  };
  const sig = JSON.stringify(attrs);
  // Atributos imperativos: React 19 asigna props como propiedades y el componente expone getters de solo lectura.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    Object.entries(JSON.parse(sig)).forEach(([k, v]) => {
      if (v === null) { if (el.hasAttribute(k)) el.removeAttribute(k); }
      else if (el.getAttribute(k) !== v) el.setAttribute(k, v);
    });
  }, [sig]);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !fx || el.getAttribute("fx") === fx) return;
    const face = av && FX_FACE[fx.split("-")[0]];
    if (!face) { el.setAttribute("fx", fx); return; }
    let live = true;
    ensureFace(`${av.dir}${face}.webp`).then(() => { if (live) el.setAttribute("fx", fx); });
    return () => { live = false; };
  }, [fx, av]);
  return createElement("hit-avatar", { ref, class: className, "data-testid": testid, style: { width: size, height: size } });
};

export default HitAvatar;
